import { useSelector } from 'react-redux'
import { Roles } from '../interface/Enums/Roles.enum'
const useAuthLevel = (): Roles => {
  const authLevel = useSelector((state: {
    auth: { user: { authLevel: Roles } }
  }) => state.auth.user.authLevel)
  return authLevel
}

export default useAuthLevel